import { render, staticRenderFns } from "./Ordem.vue?vue&type=template&id=1e57926d&scoped=true&"
import script from "./Ordem.vue?vue&type=script&lang=js&"
export * from "./Ordem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e57926d",
  null
  
)

export default component.exports